module.exports = __webpack_public_path__ + "img/icon-02.4bf3b547.svg";